import { Component } from '@angular/core';
import { PersistStorageKeys, PersistStorageService } from '../../services/persist-storage.service';

@Component({
  selector: 'app-coverage-information',
  templateUrl: './coverage-information.component.html',
})
export class CoverageInformationComponent {
  visible = !this.persistStorage.getBoolean(PersistStorageKeys.CoverageInformationClosed);

  constructor(private persistStorage: PersistStorageService) {}

  close() {
    this.persistStorage.setBoolean(PersistStorageKeys.CoverageInformationClosed, true);
    this.visible = false;
  }
}
